import React from 'react';

interface AdSpaceProps {
  position: 'left' | 'right';
}

export const AdSpace: React.FC<AdSpaceProps> = ({ position }) => {
  return (
    <div className="h-full sticky top-16 overflow-hidden" data-ad-slot={position}>
      {/* Ad units: load AdSense script via scheduleDeferredAdsense in Layout; push slots here when ready. */}
    </div>
  );
};